module.exports = __webpack_public_path__ + "img/p3-wap.f67ca11b.png";